<div class="flex flex-col gap-9 p-8">
  <div
    class="flex w-full flex-col gap-4 rounded-2xl border border-surface-300 px-9 pb-4 pt-9">
    <div class="flex justify-between">
      <h4 class="font-medium text-surface-700" i18n>Personal Information</h4>
      <span
        class="inline-flex cursor-pointer items-center gap-2"
        (click)="toggleGeneralEditDialog()">
        <ng-icon name="phosphorPencilSimple" class="text-xl"></ng-icon>
        <ng-container i18n>Edit</ng-container>
      </span>
    </div>

    <div>
      <div
        class="grid h-14 grid-cols-2 items-center border-b border-surface-300">
        <span class="text-sm text-surface-500" i18n>Name</span>
        <span class="text-sm text-surface-500">{{
          lodash.startCase(
            userStore.get().first_name + ' ' + userStore.get().last_name
          )
        }}</span>
      </div>

      <div class="grid h-14 grid-cols-2 items-center">
        <span class="text-sm text-surface-500" i18n>Birthdate</span>
        <span class="text-sm text-surface-500">{{ getBirthdate() }}</span>
      </div>
    </div>
  </div>
  <div
    class="flex w-full justify-between rounded-2xl border border-surface-300 p-9">
    <h4 class="font-medium text-surface-700" i18n>Password</h4>
    <span
      class="inline-flex cursor-pointer items-center gap-2"
      (click)="togglePasswordEditDialog()">
      <ng-icon name="phosphorPencilSimple" class="text-xl"></ng-icon>
      <ng-container i18n> Reset password </ng-container>
    </span>
  </div>
</div>

<p-dialog
  class="dialog-content-show-overflow"
  header="aaaa"
  [modal]="true"
  [visible]="generalEditDialogVisible()"
  (visibleChange)="generalDialogVisibiliyChanged()">
  <ng-template #headless>
    <general-edit (close)="toggleGeneralEditDialog()"></general-edit>
  </ng-template>
</p-dialog>

<p-dialog
  [modal]="true"
  [visible]="passwordEditDialogVisible()"
  (visibleChange)="passwordDialogVisibiliyChanged()">
  <ng-template #headless>
    <change-password-page
      (close)="togglePasswordEditDialog()"></change-password-page>
  </ng-template>
</p-dialog>
